<template>
	<div>
		<div class="header">
			<div class="navbar">
				<div class="container-fluid">
          <!-- :style="{'background':`url(${settingPc && settingPc.logo_img?settingPc.logo_img.file_path:'../static/images/header_logo.png'})`}"  -->
					<div class="navbar-brand" :style="{'background':`url(${settingPc && settingPc.logo_img?settingPc.logo_img.file_path:''})`}">
						<a href="/">
              <!-- <img :src="settingPc && settingPc.logo_img?settingPc.logo_img.file_path:''" class="logo" /> -->
<!-- 							<span class="logo" >



							</span> -->
               <!-- <div style="text-align: center;color: #fff;">大庆趣享网络科技有限公司</div> -->
						</a>
					</div>
					<div class="navbar-primary">
						<ul class="navbar-nav clearfix">
							<li class="navbar-home">
								<a href="/">
									<i class="iconfont icon-shouye"></i>
									<span>首页</span>
								</a>
							</li>

							<li id="navbar-sell"  v-on:mouseover="changeActive($event)"  v-on:mouseout="removeActive($event)" data-hover='dropdown'>
								<router-link :to="{path:'/shop'}" @click.native="flushCom">

									<i class="iconfont icon-a-youhuiquankaquanduozhangkaquan"></i>
									<span>卡券回收</span>
								</router-link>
								<div class="dropdown-menu animated zoomIn">
									<ul class="navbar-cardnav clearfix">
										<li v-for="(item,index) in cardList" :key="index">
											<a>
											<router-link :to="{path:'/shop?cateid='+item.cate_id}" @click.native="flushCom">
                        <div class="qwfqwolfgjoifg">
                          <img :src="item.image.file_path"/>
                          <div class="qwfqwolfgjoifg-title">{{item.name}}</div>
                        </div>
<!-- 												<div class="card">

												</div> -->

											</router-link>
											</a>
										</li>
									</ul>
								</div>
							</li>
							<li >
								<router-link :to="{path:'/notice'}">
									<i class="iconfont icon-gonggao"></i>
									<span>平台公告</span>
								</router-link>
							</li>
              <li >
              	<router-link :to="{path:'/article'}">
              		<i class="iconfont icon-16"></i>
              		<span>卡券新闻</span>
              	</router-link>
              </li>
							<li v-on:mouseover="changeActiveWX($event)"  v-on:mouseout="removeActiveWX($event)">
								<a href="javascript:;">
									<i class="iconfont icon-weixingongzhonghao"></i>
									<span>公众号</span>
								</a>
								<div class="dropdown-menu animated zoomIn">
									<div class="navbar-download">
										<h5>手机回收更方便</h5>
										<img  :src="settingPc && settingPc.wxmp_img?settingPc.wxmp_img.file_path:''"/>
										<!-- <img src="../assets/static/images/home/gzh.jpg" /> -->
										<p class="h6">扫码关注{{$namePc}}公众号</p>
									</div>
								</div>
							</li>
							<li id="navbar-chong">
								<a href="javascript:;" @click="openUser()">
									<i class="icon-gerenzhongxin iconfont"></i>
									<span>个人中心</span>
								</a>
							</li>
						</ul>
					</div>
					<div class="navbar-customer" id="navbar-customer">
						<ul class="navbar-login clearfix">
							<li class="navbar-user userstate1" v-if="!token">
								<router-link :to="{path:'/login'}" class="btn btn-primary">登录</router-link>
								<router-link :to="{path:'/register'}" class="btn btn-default">注册</router-link>
							</li>
							<li class="navbar-user userstate2" v-if="token"  v-on:mouseover="changeActiveWX($event)"  v-on:mouseout="removeActiveWX($event)">
								<router-link  :to="{path:'/user'}" class="btn btn-primary navbar-avatar">
									<span class="avatar">
										<i class="icon-gerenzhongxin iconfont" style="font-size: 20px;"></i>
									</span>
									<span class="username">{{token?userList.user_id:""}}</span>
								</router-link>
								<div class="dropdown-menu animated zoomIn">
									<div class="navbar-account">
										<div class="navbar-account-name">
											<h3 class="ellipsis">
												<router-link :to="{path:'/user'}">我的账户</router-link>
											</h3>
										</div>
										<div class="navbar-account-nav">
											<ul class="clearfix">
												<li>
													<router-link class="btn btn-default" :to="{path:'/shop'}">
														<i></i>
														我要卖卡
													</router-link>
												</li>
												<li>
													<router-link class="btn btn-default" :to="{path:'/order'}">
														<i></i>
														卖卡记录
													</router-link>
												</li>
												<li>
													<router-link class="btn btn-default" :to="{path:'/withdraw'}">
														<i></i>
														我要提现
													</router-link>
												</li>
												<li>
													<router-link class="btn btn-default" :to="{path:'/withdrawList'}">
														<i></i>
														提现记录
													</router-link>
												</li>
											</ul>
										</div>
										<div class="navbar-account-set clearfix">
											<router-link :to="{path:'/setting'}" class="pull-left">资料管理</router-link>
											<a href="javascript:;" class="pull-right" @click="$commonJs.getOut">
												安全退出
											</a>
										</div>
									</div>
								</div>
							</li>
							<li class="navbar-help" v-on:mouseover="changeActiveWX($event)"  v-on:mouseout="removeActiveWX($event)">
								<a class="navbar-icon" href="javascript:;">
									<i class="el-icon-help" style="font-size: 30px;"></i>
								</a>
								<div class="dropdown-menu help-sliok animated zoomIn">
									<p class="link help-link">
										<router-link :to="{path:'/problem'}">常见问题</router-link>
										<em class="sep">|</em>
										<router-link :to="{path:'/flow'}">卖卡流程</router-link>
									</p>
									<p class="tel help-tel">
										或直接拨打客服热线
										<br>
										<span class="text-red h2">{{settingPc && settingPc.service_phone?settingPc.service_phone:'-'}}</span>
										<br>
										<small class="text-light">{{settingPc && settingPc.work_time?settingPc.work_time:''}}</small>
									</p>
									<p class="link help-link">
										<a class="btn btn-primary btn-block zhiCustomBtn" href="javascript:;"  @click="$fxLink.checkServier">在线客服咨询</a>
									</p>
								</div>
							</li>
							<li class="navbar-hezuo" >
								<a class="navbar-icon" href="javascript:;" @click="$fxLink.checkServier">
									<i class="el-icon-service" style="font-size: 30px;"></i>
								</a>
							</li>
						</ul>
					</div>
				</div>
			</div>
		</div>
		<dl class="toolbar" id="toolbar">
			<dt v-on:mouseover="changeActiveWX($event)"  v-on:mouseout="removeActiveWX($event)">
				<a href="javascript:;" @click="$fxLink.checkServier">
					<i class="iconfont iconfont-service icon-kefu"></i>
					<span class="iconfont-text">在线咨询</span>
				</a>
				<div class="dropdown-menu dropdown-menu-call animated fadeInRight" name='el-fade-in-linear'>
					<h5>您也可以拨打客服电话：</h5>
					<p class="text-red h2">{{settingPc.service_phone?settingPc.service_phone:'-'}}</p>
					<p class="text-light h6">{{settingPc.work_time?settingPc.work_time:''}}</p>
				</div>
			</dt>
			<dd v-on:mouseover="changeActiveWX($event)"  v-on:mouseout="removeActiveWX($event)">
				<a href="javascript:;">
					<i class="iconfont iconfont-weixin icon-weixin"></i>
					<span class="iconfont-text">
						关注
						<br>
						微信
					</span>
				</a>
				<div class="dropdown-menu dropdown-menu-weixin animated fadeInRight">
					<img :src="settingPc && settingPc.wxmp_img?settingPc.wxmp_img.file_path:''" />
					<p class="text-light h6">扫码关注微信公众号</p>
				</div>
			</dd>
			<dd >
				<router-link :to="{path:'/opinion'}">
					<i class="iconfont iconfont-weixin icon-yijianfankui"></i>
					<span class="iconfont-text">
						意见
						<br>
						反馈
					</span>
				</router-link>
			</dd>
		</dl>
	</div>
</template>

<script>
	export default {
	  name: 'Header',
	  data () {
	    return {
				imgList:[require('../static/images/home/phone.jpg'),require('../static/images/home/oil.jpg'),require('../static/images/home/game.jpg'),require('../static/images/home/film.jpg'),
				require('../static/images/home/shop.jpg'),require('../static/images/home/trip.jpg'),require('../static/images/home/cate.jpg'),require('../static/images/home/movie.jpg')
				],
				cardList:[],
				contactUs:[],
				dropdownBool:false,
				token:"",
				userList:[],
        settingPc:{}
	    }
	  },
		created() {

			this.token = localStorage.getItem('token')
			this.userList = JSON.parse(localStorage.getItem('userInfo'))
      this.settingPc = JSON.parse(localStorage.getItem('settingPc'))
      if(!this.settingPc){
        this.getSettings()
      }
      this.contactUs = JSON.parse(localStorage.getItem('datum'))
      if(!this.contactUs){
        this.getContactUs()
      }

			this.getCardList()

		},
		methods:{
			openUser(){
				let token = localStorage.getItem('token')
				if(!token){
					this.$router.push({ path:'/login'})
				}else{
					this.$router.push({ path:'/user'})
				}
			},
			flushCom:function(){
　　　　this.$router.go(0);
　　　},
      getSettings(){
        return new Promise((relove,reject) => {
          this.$api.systemsettings()
          .then(result => {
            this.settingPc = result
            localStorage.setItem('settingPc',JSON.stringify(result))
            this.$namePc = result.name
            relove(true)
          })
        })
      },
			getContactUs() {
				let token = localStorage.getItem('token')
				this.$api.connection({
						token: token,
					})
					.then(result => {
						this.contactUs = result.data
						localStorage.setItem("datum",JSON.stringify(result.data))
					})
			},
			// 卡券分类
			getCardList(){
				let token = localStorage.getItem('token')
				this.$api.list({
					token:token
				}).then(res => {
					if(res.code === 1){
						let list = res.data
						for(let i=0;i<list.length;i++){
							if(list[i].name === "积分兑"){
								continue
							}
							list[i].img = this.imgList[i]
							this.cardList.push(list[i])
						}
					}
				})
			},
			changeActive($event){
				$event.currentTarget.className = 'open'

			},
			removeActive($event){
				$event.currentTarget.className = ''
			},
			changeActiveWX($event){
				$event.currentTarget.className = 'open'
				this.dropdownBool = true
			},
			removeActiveWX($event){
				$event.currentTarget.className = ''
				this.dropdownBool = false
			},
			// dropdown-menu-up
		}
	}
</script>

<style>
	.help-sliok{
		width: 220px;
		text-align: center;
	}
	.help-link{
		color: #aaa;
		padding: 18px 25px;
		line-height: 1.4;
		overflow: hidden;
	}
	.help-tel{
		border-top: 1px dotted #eee;
		border-bottom: 1px dotted #eee;
		    padding: 18px 25px;
		    line-height: 1.4;
		    color: #383838;
		    overflow: hidden;
	}
	.navbar-help .help-sliok{ text-align: center; width: 220px; }
	.navbar-help .dropdown-menu p{ padding: 18px 25px; line-height: 1.4; color: #383838; overflow: hidden; }
	.navbar-help .dropdown-menu p.tel{ border-top: 1px dotted #eee; border-bottom: 1px dotted #eee; }
	.navbar-help .dropdown-menu p.tel span{ padding: 5px 5px 0 5px; display: inline-block; font-weight: 400; }
	.navbar-help .dropdown-menu p.tel .text-orange{ border-top: 1px solid #eee; }
	.navbar-help .dropdown-menu p.link{ color: #aaa; }
  .qwfqwolfgjoifg{
    display: flex;
    background: #f5f7fa;
    border:1px solid #f5f7fa;
    border-radius: 8px;
    align-items: center;
    height: 72px;
    width: 195px;
    padding: 0 20px;
    position: relative;
  }
  .qwfqwolfgjoifg:hover{
    border-color: #fd4830;
  }
  .qwfqwolfgjoifg img{
    height: 40px;
    width: 40px;
    max-width: 60px;
  }
  .qwfqwolfgjoifg-title{
    color: #000000;
    font-size: 18px;
        font-weight: 500;
        margin-left:80px;
  }
  .qwfqwolfgjoifg:hover > img {
  	-webkit-animation-name: swing;
  	animation-name: swing;
  	animation-duration: .5s;
  }
</style>



// WEBPACK FOOTER //
// src/components/header.vue